import { callApi, handleError, handleResponse } from '@helpers/api';

const createAccountRequest = agent => payload => agent.post('auth/account/', payload);
const updateAccountRequest = agent => (id, payload) => agent.patch(`auth/account/${id}/`, payload);
const getAccountRequest = agent => id => agent.get(`auth/account/${id}/`);
const listOrgStrApi =
  agent =>
  ({ limit = 10, offset = 0, name = '' }) =>
    agent.get(`auth/entity/?search=${name}&limit=${limit}&offset=${offset}`);

export const createAccount = async ({ companyName, address, zipCode, city, country }) =>
  callApi(createAccountRequest)({
    name: companyName,
    address,
    zip_code: zipCode,
    city,
    country,
  })
    .then(handleResponse)
    .catch(handleError);

export const getAccount = async id =>
  callApi(getAccountRequest)(id).then(handleResponse).catch(handleError);

export const updateAccount = async (
  id,
  { companyName, streetName, buildingNo, zipCode, city, country, taxNumber }
) =>
  callApi(updateAccountRequest)(id, {
    name: companyName,
    address: `${streetName} ${buildingNo}`,
    zip_code: zipCode,
    city,
    country,
    tax_number: taxNumber,
  })
    .then(handleResponse)
    .catch(handleError);

export const listOrgStr = async payload =>
  callApi(listOrgStrApi)(payload).then(handleResponse).catch(handleError);
